import React from 'react';
import SiteHeader from './../../../components/SiteHeader';

const TaskNotificationHeader = props => {
   
    const centerContent = (
        <div className="w-full">
          
        </div>
    );

    return <SiteHeader centerContent={centerContent} />;

}

export default TaskNotificationHeader
